import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import AnimakitExpander from "animakit-expander";
import moment from 'moment';

import classes from './HotelTupleStacked.scss';

import arrowBack from '../../../assets/images/arrow-back.svg';

class TupleStacked extends Component {
    state = {
        isInclusionsExpaned: false
    }

    viewInclusionsHandler = () => {
        this.setState(prevState => {
            return {isInclusionsExpaned: !prevState.isInclusionsExpaned }
        })
    }
    
    formatDateHandler = (time) => {
        var ts = time;
        var H = +ts.substr(0, 2);
        var h = (H % 12) || 12;
        h = (h < 10)?("0"+h):h;  // leading 0 at the left for 1 digit hours
        var ampm = H < 12 ? " AM" : " PM";
        ts = h + ts.substr(2, 3) + ampm;
        return ts;
    }

    render() {
        let stars = [];
        for(let i = 0; i < this.props.star; i++) {
            stars.push(<span key={i}>&#9733;</span>);
        }

        let inclusions = this.props.inclusions.map(inclusion => <li className="u-fontSize12 u-textColorNormal mb-2">- {inclusion}</li>)
        let cancellationPolicies = this.props.cancellationPolicies.map(policy => <li className="u-fontSize12 u-textColorNormal mb-2">- {policy}</li>)

        const params = new URLSearchParams(this.props.location.search);

        let checkInDate = params.get('checkInDate');
        let checkOutDate = params.get('checkOutDate');

        const checkinDateNum = moment(checkInDate, 'DD/MM/YYYY').format('DD');
        const checkinDay = moment(checkInDate, 'DD/MM/YYYY').format('dddd');
        const checkinMonth = moment(checkInDate, 'DD/MM/YYYY').format('MMMM');

        const checkoutDateNum = moment(checkOutDate, 'DD/MM/YYYY').format('DD');
        const checkoutDay = moment(checkOutDate, 'DD/MM/YYYY').format('dddd');
        const checkoutMonth = moment(checkOutDate, 'DD/MM/YYYY').format('MMMM');
        

        const totalNights = moment(checkOutDate, 'DD/MM/YYYY').diff(moment(checkInDate, 'DD/MM/YYYY'), 'days');
        const totalDays = totalNights + 1;

        return (
            <div className={`${classes.Tuple} u-flex p-6 u-backgroundColorWhite u-borderRadius4 u-boxShadowThin u-width100Percent`}>
                <div className={`${classes.ImageContainer} mr-6 u-height195`}>
                    <img src={this.props.hotelImage} alt="Hotel" className={`u-borderRadius4 u-height100Percent u-width100Percent`} /> 
                </div>
                <div className={`u-flex f-column f-fill u-width100PercentOffset21rem`}>
                    <div className={`u-textColorPrimary`}>{stars}</div>
                    <div className={`u-flex f-column`}>
                        <div>
                            <h3 className={`u-fontSize18 u-textColorDark u-fontWeightRegular`}>{this.props.name}</h3>
                        </div>
                        <div className={`u-fontSize11`}>
                            <span className={`u-fontWeightMedium u-textColorNormal mr-2`}>{this.props.city}</span>
                            <span className={`u-fontWeightRegular u-textColorLight`}>{this.props.address} Pincode - {this.props.pinCode}</span>
                        </div>
                    </div>
                    <div className={`u-flex u-borderTopNormal u-borderBottomNormal pt-2 pb-2 mt-3 mb-3`}>
                        <div className={`u-flex f-column`}>
                            <div>
                                <p className={`u-fontSize11 u-textColorLight u-textUppercase`}>Check-In</p>
                            </div>
                            <div className={`u-flex`}>
                                <div className={`ml-3 mr-3`}>
                                    <p className={`u-fontSize29 u-fontWeightMedium u-textColorDark`}>{checkinDateNum}</p>
                                </div>
                                <div className={`u-textColorDark u-fontSize12 u-lineHeight1 align-self-center`}>
                                    <div className={`mb-1`}>
                                        <p className={`u-fontWeightRegular`}>{checkinMonth}</p>
                                    </div>
                                    <div>
                                        <p className={`u-fontWeightMedium`}>{checkinDay}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`ml-4 mr-4 align-self-center`}>
                            <img src={arrowBack} className={`u-rotate180deg`} alt="Arrow" />
                        </div>
                        <div className={`u-flex f-column`}>
                            <div>
                                <p className={`u-fontSize11 u-textColorLight u-textUppercase`}>Check-Out</p>
                            </div>
                            <div className={`u-flex align-items-center`}>
                                <div className={`ml-3 mr-3`}>
                                    <p className={`u-fontSize29 u-fontWeightMedium u-textColorDark`}>{checkoutDateNum}</p>
                                </div>
                                <div className={`u-textColorDark u-fontSize12 u-lineHeight1 align-self-center`}>
                                    <div className={`mb-1`}>
                                        <p className={`u-fontWeightRegular`}>{checkoutMonth}</p>
                                    </div>
                                    <div>
                                        <p className={`u-fontWeightMedium`}>{checkoutDay}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`u-flex f-column justify-content-between ml-6`}>
                            <div>
                                <p className={`u-fontSize11 u-textColorLight u-textUppercase`}>Duration</p>
                            </div>
                            <div className={`u-fontSize12 u-textColorNormal`}>
                                <p>{totalDays} Days</p>
                                <p>{totalNights} Nights</p>
                            </div>
                        </div>
                        <div className={`u-flex f-column justify-content-between ml-6`}>
                            <div>
                                <p className={`u-fontSize11 u-textColorLight u-textUppercase`}>Policy</p>
                            </div>
                            <div className={`u-fontSize12`}>
                                <p className="u-textColorLight">Checkin: <span className="u-textColorNormal">{this.formatDateHandler(this.props.checkInTime)}</span></p>
                                <p className="u-textColorLight">Checkout: <span className="u-textColorNormal">{this.formatDateHandler(this.props.checkOutTime)}</span></p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <p onClick={this.viewInclusionsHandler} className={`u-textColorPrimary u-fontSize15 u-cursorPointer`}>View Inclusion &amp; Cancellation Policy</p>
                    </div>
                    <AnimakitExpander
                        expanded={this.state.isInclusionsExpaned}
                        duration={400}
                        align="bottom">
                        <div>
                            <ul>
                                {inclusions}
                            </ul>
                            <div><p className="u-fontSize12 u-fontWeightMedium u-textColorDark">Cancellation Policy:</p></div>
                            <ul>
                                {cancellationPolicies}
                            </ul>
                        </div>
                    </AnimakitExpander>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        star: state.hotels.reviewStar,
        name: state.hotels.reviewHotelName,
        address: state.hotels.reviewAddress,
        city: state.hotels.reviewCity,
        pinCode: state.hotels.reviewPinCode,
        hotelImage: state.hotels.reviewImageURL,
        checkInTime: state.hotels.reviewCheckIn,
        checkOutTime: state.hotels.reviewCheckOut,
        inclusions: state.hotels.reviewInclusions,
        cancellationPolicies: state.hotels.reviewCancellationPolicies
    }
}

export default withRouter(connect(mapStateToProps)(TupleStacked));


// WEBPACK FOOTER //
// ./src/components/Hotel/HotelTupleStacked/HotelTupleStacked.js